export default "__VITE_ASSET__D7rKPMkn__"